import { useBanners } from '../hooks/useBanners';
import { BannerContenido } from './BannerContenido';

/**
 * Franja de noticias, promociones y avisos.
 *
 * Se coloca donde haga falta (`<BannerSlot />`) y no recibe contenido: lo que
 * se muestra lo deciden el JSON de storage y la segmentación del servidor. Si
 * no hay nada vigente para este usuario, no ocupa espacio.
 *
 * NO se puede cerrar. Quitar un banner es una decisión de quien lo publica, no
 * de quien lo lee: se apaga desde /admin/banners (`isActive: false`) o dejando
 * pasar su `endDate`, y en ambos casos desaparece de todos los clientes sin
 * desplegar nada. Darle una X al usuario haría que un aviso obligatorio —un
 * mantenimiento programado, por ejemplo— dependiera de que no le hubiera dado
 * clic tres días antes.
 */
export function BannerSlot() {
  const { data: banners } = useBanners();

  // Mayor `priority` primero — misma regla que el portal legado, para que un
  // aviso importante no quede debajo de una promoción en un portal y encima en
  // el otro.
  const visibles = [...(banners ?? [])].sort((a, b) => b.priority - a.priority);

  if (visibles.length === 0) return null;

  return (
    <div className="space-y-3">
      {visibles.map((banner) => (
        <div key={banner.id} data-testid={`portal-banner-${banner.id}`}>
          <BannerContenido banner={banner} />
        </div>
      ))}
    </div>
  );
}
